<template>
	<div>
		<b-form>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">GT</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="gtStatus"
							v-model="nsimForm.gt"
							:readonly="true"
						></b-form-input>
						<b-form-invalid-feedback :state="gtStatus"> Please enter a valid gt </b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>

			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Metric</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="metricStatus"
							type="number"
							v-model="nsimForm.metric"
						></b-form-input>
						<b-form-invalid-feedback :state="metricStatus">
							Please select a valid Metric.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Name</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input id="input-1" :state="nameStatus" v-model="nsimForm.name"></b-form-input>
						<b-form-invalid-feedback :state="nameStatus">
							Please select a valid Name.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Location</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-select
							id="select-1"
							:state="locationStatus"
							v-model="nsimForm.location"
							:options="locationList"
						></b-form-select>
						<b-form-invalid-feedback :state="locationStatus">
							Please enter a valid Location.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Tadig</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input id="input-1" :state="tadigStatus" v-model="nsimForm.tadig"></b-form-input>
						<b-form-invalid-feedback :state="tadigStatus">
							Please enter a valid tadig.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Sigla</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input id="input-1" :state="siglaStatus" v-model="nsimForm.sigla"></b-form-input>
						<b-form-invalid-feedback :state="siglaStatus">
							Please enter a valid sigla.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<hr />
			<div class="mt-3 d-flex justify-content-between">
				<base-button type="white" title="Close" v-on:click="modalClose()"> Close </base-button>
				<base-button
					v-if="!update"
					type="primary"
					title="Save"
					v-on:click="saveSubmit"
					:loading="submitLoading"
				>
					Saveasdf
				</base-button>
				<base-button
					v-if="update"
					type="primary"
					title="Save"
					v-on:click="saveUpdateSubmit"
					:loading="submitLoading"
				>
					Save
				</base-button>
			</div>
		</b-form>
	</div>
</template>

<script>
import {VueTelInput} from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import handleResponse from "../../../../common/directive/handlResponse";
import productManagementService from "../../../../common/api-services/product-management-service";

export default {
	name: "Nsim-Form",
	props: ["update"],
	components: {
		VueTelInput,
	},
	computed: {
		gtStatus() {
			return this.nsimForm.gt.length > 0 && !this.nsimForm.gt.includes(" ");
		},
		metricStatus() {
			return this.nsimForm.metric != "";
		},
		nameStatus() {
			return this.nsimForm.name.length > 0;
		},
		tadigStatus() {
			return this.nsimForm.tadig.length > 0;
		},
		locationStatus() {
			return this.nsimForm.location.length > 0;
		},
		siglaStatus() {
			return this.nsimForm.sigla.length > 0;
		},
	},
	data() {
		return {
			nsimForm: {
				gt: 0,
				metric: "",
				name: "",
				carrier: "",
				location: "",
				tadig: "",
				sigla: "",
			},
			locationList: [],
			submitLoading: false,
		};
	},
	mounted() {
		this.getLocationList();

		this.$root.$on("ChangeNsimOldData", res => {
			this.nsimForm.gt = res.gt;
			this.nsimForm.metric = res.metric;
			this.nsimForm.name = res.name;
			this.nsimForm.location = res.location;
			this.nsimForm.tadig = res.tadig;
			this.nsimForm.sigla = res.sigla;
		});

		if (!this.update) {
			this.generateRandomValue();
		}
	},
	methods: {
		modalClose() {
			this.$bvModal.hide("add-nsim");
			this.$bvModal.hide("edit-nsim");
		},

		async saveSubmit() {
			if (
				this.nsimForm.gt != "" &&
				this.nsimForm.metric != "" &&
				this.nsimForm.name != "" &&
				this.nsimForm.location != "" &&
				this.nsimForm.tadig != "" &&
				this.nsimForm.sigla != ""
			) {
				this.submitLoading = true;

				const save = await productManagementService.addNsim(this.nsimForm);

				this.modalClose();
				this.$root.$emit("getNsimListFunc");
			} else {
				this.$root.$emit("danger", "Please input valid data");
			}
		},

		async saveUpdateSubmit() {
			if (
				this.nsimForm.gt != "" &&
				this.nsimForm.metric != "" &&
				this.nsimForm.name != "" &&
				this.nsimForm.location != "" &&
				this.nsimForm.tadig != "" &&
				this.nsimForm.sigla != ""
			) {
				this.submitLoading = true;

				const save = await productManagementService.updateNsim(this.nsimForm);

				this.modalClose();
				this.$root.$emit("getNsimListFunc");
			} else {
				this.$root.$emit("danger", "Please input valid data");
			}
		},

		generateRandomValue() {
			let generate = Math.floor(10000000 + Math.random() * 90000000).toString();
			this.nsimForm.gt = generate;
		},

		async getLocationList() {
			let arr = ["*"];
			await productManagementService
				.getNsimLocations()
				.then(res => {
					// console.log(res)
					res.forEach(item => {
						if (item.location != "*" || item.location != "") {
							arr.push(item.location);
						}
					});
					this.locationList = arr;
				})
				.catch(err => {
					if (process.env.NODE_ENV === "development") {
						console.log(err);
					}
					this.$toast.error(err.message);
				});
		},

		// validateInput() {
		//   this.nsimForm.metric = this.nsimForm.metric.replace(/[^0-9]/g, "");
		// },
	},
};
</script>
